import { useState, useEffect } from 'react';

// Détecte si on est sur un téléphone (pas une tablette, pas un desktop).
// On combine :
//  - User-Agent (Mobi/iPhone/Android+Mobile…)
//  - taille réelle de l'écran (window.screen.width) pour court-circuiter
//    le mode "Site pour ordinateur" de Chrome/Samsung Internet qui ment
//    sur le viewport (souvent 1280px alors que le device fait 412px).
//  - pointer: coarse + petit écran physique
function detect() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;
  // Fallback : pointeur tactile + petit écran physique
  const screenW = (typeof window.screen !== 'undefined' && window.screen.width) || 9999;
  const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (coarse && screenW < 900) return true;
  return false;
}

export default function useIsPhone() {
  const [isPhone, setIsPhone] = useState(detect);
  useEffect(() => {
    // En cas de rotation / redimensionnement, on recalcule (rare mais propre)
    const onResize = () => setIsPhone(detect());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);
  return isPhone;
}
